import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate('/dashboard');
  };

  return (
    <Layout>
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 120px)',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            textAlign: 'center',
            maxWidth: '600px',
            width: '100%',
          }}
        >
          <ErrorOutlineIcon
            color="error"
            sx={{ fontSize: '64px', mb: 2 }}
          />
          <Typography variant="h4" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" paragraph>
            You don't have permission to access this page. This might be because:
          </Typography>
          <Typography variant="body1" component="div" align="left" sx={{ mb: 3 }}>
            <ul>
              <li>Your current role doesn't have the required privileges.</li>
              <li>The administrator has not granted you access to this feature.</li>
              <li>You need to request additional permissions from your administrator.</li>
            </ul>
          </Typography>
          <Button variant="contained" color="primary" onClick={handleReturn}>
            Return to Dashboard
          </Button>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UnauthorizedPage; 